import {z} from 'zod'

const TraitCategoryOptionSchema = z.object({
  id: z.union([z.number(), z.string()]),
  name: z.string(),
  value: z.string(),
})

const TraitCategoryOperatorValueSchema = z.object({
  options: z.array(TraitCategoryOptionSchema).nullable(),
  valueType: z.string(),
})

const TraitCategoryOperatorSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  value: TraitCategoryOperatorValueSchema.nullable(),
})

const TraitCategoryTraitSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  active: z.boolean().nullable(),
  priority: z.number().nullable(),
  operator: z.array(TraitCategoryOperatorSchema),
  id_traittype: z.number().nullable(),
  logical_type: z.string().nullable(),
})

export const TraitCategorySchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  active: z.boolean(),
  traits: z.array(TraitCategoryTraitSchema),
  display_order: z.number(),
})

export const GetTraitCategoriesRequestSchema = z.void()
export const GetTraitCategoriesResponseSchema = z.array(TraitCategorySchema)

export type TraitCategory = z.infer<typeof TraitCategorySchema>
export type TraitCategoryTrait = z.infer<typeof TraitCategoryTraitSchema>
export type TraitCategoryOperator = z.infer<typeof TraitCategoryOperatorSchema>
export type TraitCategoryOption = z.infer<typeof TraitCategoryOptionSchema>
export type TraitCategories = TraitCategory[]
export type GetTraitCategoriesRequest = z.infer<typeof GetTraitCategoriesRequestSchema>
export type GetTraitCategoriesResponse = z.infer<typeof GetTraitCategoriesResponseSchema>
